module.exports = __webpack_public_path__ + "static/media/sendBackwards.e345c433.svg";